@if (isTechnicalSupportWelcome) {
  <div class="welcome-box">
    <i class="ph ph-chat-circle"></i>
    <div class="content">
      <span class="title">
        {{ 'doktar_app.communications.no_chat_yet' | translate }}
      </span>
      <span class="subtitle">
        {{ 'doktar_app.communications.no_chat_yet_subtitle' | translate }}
      </span>
    </div>
    <dk-button
      [label]="'doktar_app.communications.tech_support.contact_tech_support_button' | translate"
      [size]="'xlarge'"
      [severity]="'primary'"
      (onClick)="createTechnicalSupportInquiry()"></dk-button>
  </div>
} @else if (isCreatingTechnicalSupportInquiry) {
  <div class="create-inquiry-box">
    <form [formGroup]="createTechnicalSupportInquiryForm" (ngSubmit)="createTechnicalSupportInquiryWithDetails()">
      <div *ngFor="let category of categories" class="field-checkbox">
        <label [for]="category.key" class="ml-2">{{ category.name | translate }}</label>
        <p-radiobutton [inputId]="category.key" [value]="category" formControlName="selectedCategory" />
      </div>
      @if (isDeviceCategorySelected) {
        <div class="devices">
          <span class="device-label">
            {{ 'doktar_app.common.device_id_label' | translate }}
          </span>
          @if (loadingDevices) {
            <dk-skeleton
              [skeletonConfig]="{
                size: 1,
                layout: 'horizontal',
                width: '100%',
                height: '48px',
              }"></dk-skeleton>
          } @else {
            <dk-select
              [options]="devices"
              [filter]="true"
              [appendTo]="'body'"
              [formGroup]="createTechnicalSupportInquiryForm"
              [validationControl]="false"
              [optionLabel]="'label'"
              [optionValue]="'value'"
              [controlName]="'selectedDevices'"></dk-select>
          }
        </div>
      }
      <div class="description">
        <div class="title">
          <span class="label">
            {{ 'doktar_app.common.description_label' | translate }}
          </span>
          <span class="count"
            >{{ (createTechnicalSupportInquiryForm.get('description').value || '').length }} /
            {{ descriptionMessageSize }}</span
          >
        </div>
        <textarea
          rows="5"
          cols="30"
          [maxlength]="descriptionMessageSize"
          pTextarea
          formControlName="description"
          [placeholder]="'doktar_app.communications.tech_support.description_placeholder' | translate"></textarea>
      </div>
      <dk-button
        [label]="'doktar_app.communications.tech_support.contact_tech_support_button' | translate"
        [size]="'xlarge'"
        [severity]="'primary'"
        [disabled]="!createTechnicalSupportInquiryForm.valid || creatingInquiry"
        [loading]="creatingInquiry"
        type="submit"></dk-button>
      <dk-button
        [label]="'doktar_app.common.cancel_button' | translate"
        [size]="'xlarge'"
        [severity]="'secondary'"
        [disabled]="creatingInquiry || !createTechnicalSupportInquiryForm.valid"
        (click)="cancelCreateInquiry()"></dk-button>
    </form>
  </div>
} @else if (isChatOpen) {
  <dk-support-chat-panel [inquiryId]="inquiryId"></dk-support-chat-panel>
}
